<template>
  <div>
    <div class="SecurityGroup-title">
      <div>{{ $t("RAM.AWS.SecurityGroup.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:securityGroup:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:securityGroup:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="SecurityGroup-top">
      <security-group-search
        ref="securityGroupSearchChild"
      ></security-group-search>
    </div>
    <table-security-group></table-security-group>
  </div>
</template>

<script>
import SecurityGroupSearch from "../security_group/SecurityGroupSearch";
import TableSecurityGroup from "../security_group/TableSecurityGroup";

export default {
  name: "SecurityGroup",
  components: {
    SecurityGroupSearch,
    TableSecurityGroup
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      groupIdSearchKey: "",
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.securityGroupSearchChild.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 12
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.groupIdSearchKey = this.$refs.securityGroupSearchChild.groupIdSearchKey;
      this.companyId = this.$refs.securityGroupSearchChild.companyId;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAWSSecurityGroup({
          groupId: this.groupIdSearchKey,
          companyId: this.companyId
        })
        .then(res => {
          let fileName = "安全组.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.SecurityGroup-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.SecurityGroup-title > div:nth-child(1) {
  float: left;
}
.SecurityGroup-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.SecurityGroup-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/security_group/SecurityGroup.vue